import React, {Component} from "react";
import NewsHeader from "./NewsHeader";
import NewsList from "./NewsList";
import NewsListItems from "./NewsListItems";
import NewsItem from "./NewsItem";
import Loading from "../../components/Loading";
import SportsNews from "../../constants/SportsNews";
import Sort from "../../helpers/Sort";
import {connect} from "react-redux";
import {getNews} from "../../redux/actions/news";

class NewsContainer extends Component {
	componentWillMount() {
		if ( this.props.news[this.props.type].length === 0 ) {
			this.props.onGetNews(this.props.type, 50);
		}
	}

	render() {
		const {type, news} = this.props;

		const news_list = type === 'site' ? news[type].slice() : news[type].filter((item) => {return item.cat_id !== 5});
		news_list.sort(Sort.orderByTime).reverse();

		return (
			<div className="body__container__side-right bg-news">
				<div className="news">
					<NewsHeader type={type}/>

					{news.fetching && <Loading/>}
					<NewsList>
						<NewsListItems>
							{news_list.map((item) =>
								<NewsItem key={`news-${item.id}`} data={item} sports={SportsNews} type={type}/>)}
						</NewsListItems>
					</NewsList>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		news       : state.news,
	}),
	dispatch => ({
		onGetNews : (type, limit) => {
			dispatch(getNews(type, limit))
		}
	})
)(NewsContainer);


// WEBPACK FOOTER //
// ./src/app/pages/News/NewsContainer.js